import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import Cloth1 from "../../assets/images/product/cloth-1.avif";
import Cloth2 from "../../assets/images/product/cloth-2.avif";
import Cloth3 from "../../assets/images/product/cloth-3.avif";
import Cloth4 from "../../assets/images/product/cloth-4.avif";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import ProductTag from "./ProductTag";

const fadeSlideIn = keyframes`
  0% {
    opacity: 0.2;
  }
  50%{
    opacity : 0.6;
  }
  100% {
    opacity: 1;
  }
`;
const fadeSlideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(25px);
  }
  
  100% {
    opacity: 1;
  }
`;
const Popup = styled.div`
  position: absolute;
  display: flex;
  bottom: 10px;
  right: 35%;
  z-index: 2;
  padding: 10px 15px;
  background-color: ${colors.black};
  color: ${colors.backgroundSecondary};
  font-size: ${fontSize.xs};
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: none;
  animation: ${fadeSlideUp} 0.4s;

  &:hover {
    color: ${colors.backgroundSecondary};
    background-color: #424242;
  }
`;
const Image = styled.div`
  height: fit-content;
  width: fit-content;
  position: relative;
  overflow: hidden;

  img {
    width: 330px;
    height: 495px;
    object-fit: cover;
    transition:
      transform 0.3s ease,
      opacity 0.2s ease;
    animation: ${fadeSlideIn} 0.4s ease-out;
    display: block;
  }

  &:hover img {
    transform: scale(1.025);
  }
`;
const Wrapper = styled.div`
  cursor: pointer;
  &:hover {
    ${Popup} {
      display: initial;
    }
    img {
      transform: scale(1.025);
    }
  }
`;

const Tag = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const ProductName = styled.div`
  font-size: ${fontSize.l};
  font-weight: 300;
`;

const Price = styled.div`
  font-size: ${fontSize.m};
  font-weight: 500;
`;

const Picker = styled.div`
  ul {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 10px 0;
  }

  li {
    list-style: none;
    height: 14px;
    width: 14px;
    background-color: ${colors.backgroundSurfaceSecondary};
    border: 1px solid ${colors.border};
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 2px;
  }

  li:hover {
    transform: scale(1.1);
    border-color: ${colors.black};
  }

  li[data-selected="true"] {
    height: 15px;
    width: 15px;
    background-color: ${colors.border};
    border: 2px solid ${colors.black};
    transform: scale(1.05);
  }
`;
const Discounted = styled.div`
  display: flex;
  gap: 10px;
  span {
    color: #a91313;
    text-decoration: line-through;
  }
  div {
    color: #2b732b;
  }
`;

function ProductCard({ product }) {
  const [selectedPickerIndex, setSelectedPickerIndex] = useState(0);
  const [imageKey, setImageKey] = useState(0);
  const images = [Cloth1, Cloth2, Cloth3, Cloth4];
  const navigate = useNavigate();

  const handleImageChange = (index) => {
    if (index !== selectedPickerIndex) {
      setSelectedPickerIndex(index);
      setImageKey((prev) => prev + 1);
    }
  };

  return (
    <Wrapper
      onClick={() => {
        navigate(`/product/${product._id}`);
      }}
    >
      <Image>
        <img
          key={imageKey}
          src={
            process.env.REACT_APP_IMAGE_BASE_URL +
            product.images[selectedPickerIndex].path
          }
          alt={product.name}
        />

        <Tag>
          {product.discount && product.discount > 0 ? (
            <ProductTag tagName={`${product.discount}% Off`} />
          ) : (
            <></>
          )}
        </Tag>
        <Popup>Add to cart</Popup>
      </Image>
      <Description>
        <Picker
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ul>
            {Array.from({ length: product.images.length }, (_, i) => (
              <li
                key={i}
                data-selected={selectedPickerIndex === i ? "true" : "false"}
                onClick={() => handleImageChange(i)}
              />
            ))}
          </ul>
        </Picker>
        <ProductName>{product.name}</ProductName>
        {product.discount && product.discount > 0 ? (
          <>
            <Discounted>
              <span>
                Rs. {Math.round(product.price / (1 - product.discount / 100))}
              </span>
              <Price>Rs. {product.price}</Price>
            </Discounted>
          </>
        ) : (
          <Price>Rs. {product.price}</Price>
        )}
      </Description>
    </Wrapper>
  );
}

export default ProductCard;
